import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const column1 = [
    { label: '明星丑闻', to: '/category/star-scandal' },
    { label: '网红塌房', to: '/category/influencer-downfall' },
    { label: '泄露聊天', to: '/category/leaked-chats' },
    { label: '反差视频', to: '/category/contrast-video' },
  ];

  const column2 = [
    { label: '关于我们', to: '/about' },
    { label: '商务合作', to: '/about#contact' },
    { label: '隐私政策', to: '/about#privacy' },
    { label: '侵权申诉', to: '/about#contact' },
  ];

  const column3 = [
    { label: '今日必看', to: '/' },
    { label: '最新爆料', to: '/category/star-scandal' },
    { label: '热门排行', to: '/' },
    { label: '吃瓜视频', to: '/category/contrast-video' },
  ];

  return (
    <footer className="bg-background-900 border-t border-background-800/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-16">
          <div>
            <h4 className="text-foreground-100 text-sm font-bold mb-5 pb-3 border-b border-background-700/50">
              频道导航
            </h4>
            <ul className="flex flex-col gap-3">
              {column1.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-foreground-400 text-sm hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-100 text-sm font-bold mb-5 pb-3 border-b border-background-700/50">
              关于本站
            </h4>
            <ul className="flex flex-col gap-3">
              {column2.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-foreground-400 text-sm hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-100 text-sm font-bold mb-5 pb-3 border-b border-background-700/50">
              快速入口
            </h4>
            <ul className="flex flex-col gap-3">
              {column3.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-foreground-400 text-sm hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-100 text-sm font-bold mb-5 pb-3 border-b border-background-700/50">
              关注我们
            </h4>
            <p className="text-foreground-400 text-sm mb-4 leading-relaxed">
              {t('site.slogan')}
            </p>
            <div className="flex items-center gap-3">
              <a
                href="http://hnqxp01.cn/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:text-primary-400 hover:bg-background-700 transition-all cursor-pointer"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a
                href="http://hnqxp01.cn/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:text-primary-400 hover:bg-background-700 transition-all cursor-pointer"
                aria-label="抖音"
              >
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a
                href="http://hnqxp01.cn/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:text-primary-400 hover:bg-background-700 transition-all cursor-pointer"
                aria-label="微信"
              >
                <i className="ri-wechat-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between pt-10 border-t border-background-800/50 gap-6">
          <div>
            <span className="text-3xl font-black text-primary-400 tracking-tight">
              {t('footer.brand')}
            </span>
            <div className="w-8 h-0.5 bg-primary-500/40 mt-2 mb-3"></div>
            <p className="text-foreground-500 text-xs leading-relaxed max-w-xs">
              {t('footer.disclaimer')}
            </p>
          </div>
          <p className="text-foreground-500 text-xs whitespace-nowrap">
            {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
}